<template>
  <base-dialog :active="winnerDialogVisible" :has-footer="true" @close="close">
    <template #title>
      <h5 class="text-lg font-medium w-full">
        {{ winnerMessage }}
      </h5>
    </template>

    <div class="p-4 text-center">
      <h1 class="text-2xl font-bold flex items-center justify-center">
        <img v-if="winnerImage" :src="winnerImage" class="h-40 mr-4 align-middle" alt="Winner image">
        <span v-if="winnerTextIsLink">
          <a target="_new" :href="winnerText"
            class="text-primary-500 hover:text-primary-600 dark:hover:text-primary-400">
            {{ winnerText }}
          </a>
        </span>
        <span v-if="!winnerTextIsLink">
          {{ winnerText }}
        </span>
      </h1>
    </div>

    <template #footer>
      <div class="flex flex-wrap justify-end gap-2">
        <button class="btn btn-secondary" @click="close">
          {{ t('common.Close') }}
        </button>
        <button v-show="showRemoveButton" class="btn btn-primary" ref="removeButton" @click="removeWinner">
          {{ t('winnerdialog.Remove') }}
        </button>
        <button v-show="showRemoveAllButton" class="btn btn-primary" @click="removeWinnerAll">
          {{ t('winnerdialog.Remove all instances') }}
        </button>
        <button v-show="showHideButton" class="btn btn-primary" @click="hideWinner">
          {{ t('winnerdialog.Hide') }}
        </button>
      </div>
    </template>
  </base-dialog>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useWheelStore } from '@/stores/useWheelStore';
import * as Util from '@utils/Util.js';
import BaseDialog from '../shared/BaseDialog.vue';

const { t } = useI18n();
const wheelStore = useWheelStore();

const emit = defineEmits(['remove-entry', 'remove-entry-all', 'hide-entry']);

const winnerDialogVisible = ref(false);
const winnerText = ref('');
const winnerImage = ref('');
const winnerEntry = ref('');

const wheelConfig = computed(() => wheelStore.wheelConfig);
const wheelIsShared = computed(() => wheelStore.wheelIsShared);

const winnerMessage = computed(() => winnerEntry.value.message || wheelConfig.value.winnerMessage);
const winnerTextIsLink = computed(() => /https?:\/\//.test(winnerText.value));

const showRemoveButton = computed(() => wheelConfig.value.displayRemoveButton && !wheelConfig.value.autoRemoveWinner);

const showRemoveAllButton = computed(() => {
  const winnerInstances = Util.getOccurences(wheelConfig.value.getTexts(), winnerText.value);
  return wheelConfig.value.displayRemoveButton && !wheelConfig.value.autoRemoveWinner && winnerInstances > 1;
});

const showHideButton = computed(() => wheelConfig.value.isAdvanced && !wheelIsShared.value && wheelConfig.value.displayHideButton && !wheelConfig.value.autoRemoveWinner);

const show = (entry) => {
  winnerEntry.value = entry;
  winnerText.value = entry.text;
  winnerImage.value = entry.image;
  winnerDialogVisible.value = true;
};

const close = () => { winnerDialogVisible.value = false; };

const removeWinner = () => {
  emit('remove-entry', winnerEntry.value);
  winnerDialogVisible.value = false;
};
const removeWinnerAll = () => {
  emit('remove-entry-all', winnerEntry.value);
  winnerDialogVisible.value = false;
};
const hideWinner = () => {
  emit('hide-entry', winnerEntry.value);
  winnerDialogVisible.value = false;
};

defineExpose({ show, close });
</script>
